const disbursementsAndRepaymentsData = [
  {
    month: ["2023", "Apr"],
    disbursement: -750000.0,
    interestAndFeesCash: 0.0,
    amortization: 0.0,
  },
  {
    month: ["2023", "May"],
    disbursement: -750000.0,
    interestAndFeesCash: 9375.0,
    amortization: 0.0,
  },
  {
    month: ["2023", "Jun"],
    disbursement: 0.0,
    interestAndFeesCash: 18750.0,
    amortization: 0.0,
  },
  {
    month: ["2023", "Jul"],
    disbursement: 0.0,
    interestAndFeesCash: 18750.0,
    amortization: 0.0,
  },
  {
    month: ["2023", "Aug"],
    disbursement: 0.0,
    interestAndFeesCash: 26096.24,
    amortization: 34320.43,
  },
  {
    month: ["2023", "Sep"],
    disbursement: 0.0,
    interestAndFeesCash: 32677.31,
    amortization: 69406.03,
  },
  {
    month: ["2023", "Oct"],
    disbursement: 0.0,
    interestAndFeesCash: 31129.9,
    amortization: 70953.44,
  },
  {
    month: ["2023", "Nov"],
    disbursement: 0.0,
    interestAndFeesCash: 29547.99,
    amortization: 72535.35,
  },
  {
    month: ["2023", "Dec"],
    disbursement: 0.0,
    interestAndFeesCash: 27930.82,
    amortization: 74152.52,
  },
  {
    month: ["2024", "Jan"],
    disbursement: 0.0,
    interestAndFeesCash: 26277.59,
    amortization: 75805.75,
  },
  {
    month: ["2024", "Feb"],
    disbursement: 0.0,
    interestAndFeesCash: 24587.5,
    amortization: 77495.84,
  },
  {
    month: ["2024", "Mar"],
    disbursement: 0.0,
    interestAndFeesCash: 22859.73,
    amortization: 79223.61,
  },
  {
    month: ["2024", "Apr"],
    disbursement: 0.0,
    interestAndFeesCash: 21093.44,
    amortization: 80989.9,
  },
  {
    month: ["2024", "May"],
    disbursement: 0.0,
    interestAndFeesCash: 47246.96,
    amortization: 179836.38,
  },
  {
    month: ["2024", "Jun"],
    disbursement: 0.0,
    interestAndFeesCash: 10455.05,
    amortization: 76003.29,
  },
  {
    month: ["2024", "Jul"],
    disbursement: 0.0,
    interestAndFeesCash: 9521.92,
    amortization: 76936.42,
  },
  {
    month: ["2024", "Aug"],
    disbursement: 0.0,
    interestAndFeesCash: 8567.97,
    amortization: 77890.37,
  },
  {
    month: ["2024", "Sep"],
    disbursement: 0.0,
    interestAndFeesCash: 7592.76,
    amortization: 78865.58,
  },
  {
    month: ["2024", "Oct"],
    disbursement: 0.0,
    interestAndFeesCash: 6595.81,
    amortization: 79862.53,
  },
  {
    month: ["2024", "Nov"],
    disbursement: 0.0,
    interestAndFeesCash: 5576.63,
    amortization: 80881.71,
  },
  {
    month: ["2024", "Dec"],
    disbursement: 0.0,
    interestAndFeesCash: 4534.73,
    amortization: 81923.61,
  },
  {
    month: ["2025", "Jan"],
    disbursement: 0.0,
    interestAndFeesCash: 3469.6,
    amortization: 82988.74,
  },
  {
    month: ["2025", "Feb"],
    disbursement: 0.0,
    interestAndFeesCash: 1113.16,
    amortization: 49928.51,
  },
  {
    month: ["2025", "Mar"],
    disbursement: -850000.0,
    interestAndFeesCash: 10625.0,
    amortization: 0.0,
  },
  {
    month: ["2025", "Apr"],
    disbursement: 0.0,
    interestAndFeesCash: 10625.0,
    amortization: 0.0,
  },
  {
    month: ["2025", "May"],
    disbursement: 0.0,
    interestAndFeesCash: 10625.0,
    amortization: 0.0,
  },
  {
    month: ["2025", "Jun"],
    disbursement: -850000.0,
    interestAndFeesCash: 29575.73,
    amortization: 38896.49,
  },
  {
    month: ["2025", "Jul"],
    disbursement: 0.0,
    interestAndFeesCash: 28708.54,
    amortization: 39763.68,
  },
];

export default disbursementsAndRepaymentsData;
